import {Button} from "antd";
import React from "react";
import {ArrowRightOutlined} from "@ant-design/icons";

const NextButton = () => {


    return (
        <Button
            icon={<ArrowRightOutlined style={{color:'#1890ff'}} />}
            shape={'circle'}
            type={'text'}
            size={'large'}
            className={'ant-btn-text-custom'}/>
    )
}

export default NextButton;